import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';

@Injectable()
export class AddHostInterceptor implements HttpInterceptor {

    constructor(private appConfig: ConfigService){}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        if(req.url.indexOf('assets/') > -1) {
          return next.handle(req);
        }

        let apiReq;
        apiReq = req.clone({ url: `${this.appConfig.apiUrl}/${req.url}`})

        return next.handle(apiReq);

    }

}
